import { useEffect, useRef } from 'react'

const LineClamp = ({ children, lines = 1 }) => {
  const ref = useRef()
  const textRef = useRef(String(children))

  useEffect(() => {
    let text = String(children)

    if (ref.current) {
      const lineHeight = parseInt(
        getComputedStyle(ref.current).getPropertyValue('line-height')
      )
      const targetHeight = lineHeight * lines

      while (ref.current.clientHeight > targetHeight) {
        text = text.slice(0, -4) + '...'
        ref.current.innerText = text
      }
      ref.current.innerText = text
    }
  }, [children])

  return <span ref={ref}>{textRef.current}</span>
}

export default LineClamp
